import { Routes, Route, Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import PlayerLogin from '../Components/Auth/PlayerLogin';
import PlayerSignup from '../Components/Auth/PlayerSignup';
import ClubLogin from '../Components/Auth/ClubLogin';
import ClubSignup from '../Components/Auth/ClubSignup';
import ForgetPass from '../Components/Auth/ForgetPass';
import Home from '../Components/Pages/Home/Home';
import Fundraise from '../Components/Pages/Fundraise/Fundraise';
import Auctionpool from '../Components/Pages/Marketplace/Auctionpool';
import AuctionOverview from '../Components/Pages/Marketplace/AuctionDetails';
import PlayerDashboard from '../Dashboard/PlayerDashboard/Dashboard/PlayerDashboard';
import ClubDashboard from '../Dashboard/ClubDashboard/Dashboard/ClubDashboard';
import Dna from '../Components/Pages/DNA/Dna';
import About from '../Components/Pages/About/About';
import GoogleTranslate from '../GoogleTranslate';
import Loader from '../Loader/Loader';
import { useEffect, useState } from 'react';
import UserDna from '../Components/Pages/DNA/UserAssesment.js/Users';
import SuccessPage from '../Components/Pages/DNA/UserAssesment.js/SuccessPage';
import TestingTET from '../Components/Pages/DNA/test';

import Dashboard from '../Admin/Pages/Dashboard/Dashboard';
import User from '../Admin/Pages/User';
import Report from '../Admin/Pages/Dashboard/Report';
import Player_profile from '../Admin/Pages/Dashboard/Player_profile';
import Nutrition_Panel from '../Dashboard/NutritionPanel/Pages/Nutrition_Panel';
import AdminLogin from '../Admin/Auth/Login';
import UserDashboard from '../Userdashboard/Pages/UserDashboard/UserDashboard';
import ClubDashboard_II from '../ClubDashboard/Pages/Dashboard/ClubDashboard_II';
import Marketplace from '../ClubDashboard/Pages/Marketplace/Marketplace';


const getValidToken = (role) => {
    const tokenKey = role === 'player' ? 'player_token' : 'club_token';
    const token = sessionStorage.getItem(tokenKey);

    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
            sessionStorage.removeItem(tokenKey);
            return null;
        }
        return token;
    } catch {
        sessionStorage.removeItem(tokenKey);
        return null;
    }
};

const getAdminToken = () => {

    const token = sessionStorage.getItem("admin_token");
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        if (decoded.exp * 1000 < Date.now()) {
            sessionStorage.removeItem("admin_token");
            return null;
        }
        return token;
    } catch {
        sessionStorage.removeItem("admin_token");
        return null;
    }
};

const ProtectedRoute = ({ role, children }) => {
    if (role === 'admin') {
        return getAdminToken() ? children : <Navigate to="/admin/login" replace />;
    }
    return getValidToken(role) ? children : <Navigate to="/" replace />;
};

function Routers() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 2000); // or adjust duration
        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {loading && <Loader />}
            <GoogleTranslate />
            <Routes>

                <Route path="/player/login" element={<PlayerLogin />} />
                <Route path="/player/signup" element={<PlayerSignup />} />
                <Route path="/club/login" element={<ClubLogin />} />
                <Route path="/club/signup" element={<ClubSignup />} />
                <Route path="/forget-password" element={<ForgetPass />} />

                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/auction" element={<Auctionpool />} />
                <Route path="/auction/details/" element={<AuctionOverview />} />
                <Route path="/my-dna" element={<Dna />} />
                <Route path="/DNASucess" element={<SuccessPage />} />
                <Route path="/MyDNA" element={<UserDna />} />
                <Route path="/fundraise" element={<Fundraise />} />
                <Route path="/test" element={<TestingTET />} />
                <Route path="/nutrition-panel" element={<Nutrition_Panel />} />

                <Route path="/player/dashboard" element={<ProtectedRoute role="player"><PlayerDashboard /></ProtectedRoute>} />
                {/* <Route path="/club/dashboard" element={<ProtectedRoute role="club"><ClubDashboard /></ProtectedRoute>} /> */}

                <Route path="/admin/login" element={<AdminLogin />} />

                <Route path="/admin/dashboard" element={<ProtectedRoute role="admin"><Dashboard /></ProtectedRoute>} />
                <Route path="/admin/user" element={<ProtectedRoute role="admin"><User /></ProtectedRoute>} />
                <Route path="/admin/report" element={<ProtectedRoute role="admin"><Report /></ProtectedRoute>} />
                <Route path="/admin/player-profile" element={<ProtectedRoute role="admin"><Player_profile /></ProtectedRoute>} />

                <Route path="/user/dashboard" element={<UserDashboard />} />
                <Route path="/club/dashboard" element={<ProtectedRoute role="club"><ClubDashboard_II /></ProtectedRoute>} />
                <Route path="/club/marketplace" element={<Marketplace />} />


                <Route path="/loader" element={<Loader />} />

            </Routes>
        </>
    );
}

export default Routers;
